<template>
    <section class="section">
        <div class="level">
            <div class="level-left">
                <div class="level-item">
                    <h1
                        v-t="`project.settings.mailing_title`"
                        class="title is-4"
                    ></h1>
                </div>
            </div>
            <div class="level-right">
                <div class="level-item">
                    <label class="switch">
                        <input v-model="isWatchingProject" type="checkbox" />
                        <span class="slider round"></span>
                    </label>
                </div>
            </div>
        </div>
        <div v-if="isWatchingProject">
            <section @click="activeDropdown = undefined">
                <div
                    v-for="(value, option) in configuration"
                    :key="option"
                    class="mb-4 px-4 py-4"
                >
                    <div class="level">
                        <div class="level-left">
                            <div class="level-item">
                                <div>
                                    <p
                                        v-t="`project.settings.${option}`"
                                        class="title is-5"
                                    ></p>
                                    <p
                                        v-t="`project.settings.${option}_desc`"
                                        class="is-6"
                                    ></p>
                                </div>
                            </div>
                        </div>
                        <div class="level-right">
                            <div class="level-item">
                                <label
                                    v-if="typeof value === 'boolean'"
                                    class="switch"
                                >
                                    <input
                                        v-model="activeConfiguration[option]"
                                        type="checkbox"
                                    />
                                    <span class="slider round"></span>
                                </label>
                                <div
                                    v-else
                                    :class="{
                                        'is-active': option == activeDropdown,
                                    }"
                                    class="dropdown"
                                >
                                    <div
                                        class="dropdown-trigger"
                                        @click.stop="activeDropdown = option"
                                    >
                                        <button
                                            class="button"
                                            aria-haspopup="true"
                                            aria-controls="dropdown-menu"
                                        >
                                            <span>{{
                                                $t(
                                                    `Constants.${activeConfiguration[option]}`
                                                ) || $t('Buttons.select')
                                            }}</span>
                                            <span class="icon is-small">
                                                <i
                                                    class="fas fa-angle-down"
                                                    aria-hidden="true"
                                                ></i>
                                            </span>
                                        </button>
                                    </div>
                                    <div
                                        id="dropdown-menu"
                                        class="dropdown-menu"
                                        role="menu"
                                    >
                                        <div class="dropdown-content">
                                            <a
                                                v-t="`Constants.${constant}`"
                                                v-for="constant in value"
                                                :key="constant"
                                                class="dropdown-item"
                                                @click="
                                                    activeConfiguration[
                                                        option
                                                    ] = constant
                                                "
                                            >
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </section>
</template>

<script>
import _ from 'underscore';
export default {
    data() {
        return {
            activeDropdown: undefined,
            configuration: {
                new_object: true,
                new_comment: true,
                mentions: true,
                thread_comments: true,
                report_frequency: ['NONE', '1D', '3D', '1W', '1M'],
            },
            activeConfiguration: {},
            defaultConfiguration: {
                new_object: true,
                new_comment: true,
                mentions: true,
                thread_comments: true,
                report_frequency: 'NONE',
            },
        };
    },
    computed: {
        projectConfiguration() {
            return JSON.parse(
                JSON.stringify(this.$store.getters.project.userConfiguration)
            );
        },
        isWatchingProject: {
            get() {
                return this.$store.getters.project.watching;
            },
            set(newValue) {
                const projectId = this.$store.getters.project._id;
                if (newValue) {
                    this.$store.dispatch('startWatchingProject', projectId);
                } else {
                    this.$store.dispatch('stopWatchingProject', projectId);
                }
            },
        },
    },
    watch: {
        activeConfiguration: {
            deep: true,
            handler() {
                this.$emit('update', this.activeConfiguration);
            },
        },
    },
    beforeMount() {
        this.activeConfiguration = _.extend(
            this.defaultConfiguration,
            this.projectConfiguration.mailing
        );
    },
    methods: {},
};
</script>

<style></style>
